




































import { Vue, Component } from "vue-property-decorator";
import { Button, SvgIcon } from "@brankas/web-ui";
import { namespace } from "vuex-class";
import { ClientInfo } from "@/types";

const clientModule = namespace("client");

@Component({
  components: {
    Button,
    SvgIcon,
  },
})
export default class RejectSuccessSummary extends Vue {
  @clientModule.State("currentClient") clientInfo!: ClientInfo;

  get companyName(): string {
    return this.clientInfo && this.clientInfo.name;
  }

  handleBack() {
    this.$emit("close");
  }
}
